<template>
  <v-col cols="12" class="pa-0">
    <v-list class="py-0 curve-list" dense>
      <v-list-item
        v-for="curve in curves"
        :key="curve.id"
        @click="$emit('editCurve', curve)"
        class="curve-element hover-list-element px-2"
        :ripple="false"
      >
        <v-list-item-content>
          <v-row no-gutters>
            <v-col cols="auto" align-self="center">
              <v-list-item-title style="max-width: 20vw">
                <v-row no-gutters class="flex-nowrap">
                  <v-col cols="auto">
                    <v-tooltip bottom color="font" max-width="300">
                      <template #activator="{ on }">
                        <div v-on="on" class="text-body-2 font-weight-regular text-truncate py-0">
                          {{ curve.name }}
                        </div>
                      </template>
                      <div style="word-break: break-all;">
                        {{ `${curve.curve_type}: ${curve.description}` }}
                      </div>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-list-item-title>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
              <dots-menu @delete="$emit('deleteCurve', curve.id)" :items="dotsItems" font-size="19px"></dots-menu>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-col>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';
export default {
  name: 'ModelingCurvesList',
  components: { DotsMenu },
  props: {
    curves: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    dotsItems: [{ name: 'delete' }],
  }),
};
</script>

<style scoped lang="scss">
.curve-element {
  @include border(bottom);
  text-align: left;
  min-height: 36px;
  max-height: 36px;
}
.curve-list {
  border-radius: 4px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 0px rgba(0, 0, 0, 0.15) !important;
}
</style>
